export default data => {
  return data.filter(element => element[1] !== "");
};
